/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetQuestionDto } from './GetQuestionDto';
import {
    GetQuestionDtoFromJSON,
    GetQuestionDtoFromJSONTyped,
    GetQuestionDtoToJSON,
} from './GetQuestionDto';
import type { GetSurveyCompanyDto } from './GetSurveyCompanyDto';
import {
    GetSurveyCompanyDtoFromJSON,
    GetSurveyCompanyDtoFromJSONTyped,
    GetSurveyCompanyDtoToJSON,
} from './GetSurveyCompanyDto';
import type { GetSurveyEmployeeDto } from './GetSurveyEmployeeDto';
import {
    GetSurveyEmployeeDtoFromJSON,
    GetSurveyEmployeeDtoFromJSONTyped,
    GetSurveyEmployeeDtoToJSON,
} from './GetSurveyEmployeeDto';

/**
 * 
 * @export
 * @interface GetSurveyDto
 */
export interface GetSurveyDto {
    /**
     * 
     * @type {string}
     * @memberof GetSurveyDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetSurveyDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyDto
     */
    nameEn: string;
    /**
     * 
     * @type {Array<GetQuestionDto>}
     * @memberof GetSurveyDto
     */
    questions?: Array<GetQuestionDto>;
    /**
     * 
     * @type {Array<GetSurveyCompanyDto>}
     * @memberof GetSurveyDto
     */
    surveyCompanies?: Array<GetSurveyCompanyDto>;
    /**
     * 
     * @type {Array<GetSurveyEmployeeDto>}
     * @memberof GetSurveyDto
     */
    surveyEmployees?: Array<GetSurveyEmployeeDto>;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyDto
     */
    frequency: GetSurveyDtoFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyDto
     */
    contractorType: GetSurveyDtoContractorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSurveyDto
     */
    validityPeriodDays: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetSurveyDto
     */
    remind: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSurveyDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetSurveyDto
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSurveyDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyDto
     */
    emailSubject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyDto
     */
    emailSubjectEn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyDto
     */
    emailBody?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyDto
     */
    emailBodyEn?: string | null;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetSurveyDto
     */
    contactType?: GetDictionaryDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetSurveyDto
     */
    sendToGeneral?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyDto
     */
    clientGroupId?: string | null;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetSurveyDto
     */
    owner?: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetSurveyDto
     */
    ts?: Date;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetSurveyDto
     */
    creator?: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetSurveyDto
     */
    creationTs?: Date;
}


/**
 * @export
 */
export const GetSurveyDtoFrequencyEnum = {
    OnceAYear: 'OnceAYear',
    SemiAnnually: 'SemiAnnually',
    Quarterly: 'Quarterly',
    Monthly: 'Monthly'
} as const;
export type GetSurveyDtoFrequencyEnum = typeof GetSurveyDtoFrequencyEnum[keyof typeof GetSurveyDtoFrequencyEnum];

/**
 * @export
 */
export const GetSurveyDtoContractorTypeEnum = {
    All: 'All',
    Purchaser: 'Purchaser',
    Supplier: 'Supplier',
    Group: 'Group'
} as const;
export type GetSurveyDtoContractorTypeEnum = typeof GetSurveyDtoContractorTypeEnum[keyof typeof GetSurveyDtoContractorTypeEnum];


/**
 * Check if a given object implements the GetSurveyDto interface.
 */
export function instanceOfGetSurveyDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "nameEn" in value;
    isInstance = isInstance && "frequency" in value;
    isInstance = isInstance && "contractorType" in value;
    isInstance = isInstance && "validityPeriodDays" in value;
    isInstance = isInstance && "remind" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetSurveyDtoFromJSON(json: any): GetSurveyDto {
    return GetSurveyDtoFromJSONTyped(json, false);
}

export function GetSurveyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSurveyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'name': json['name'],
        'nameEn': json['nameEn'],
        'questions': !exists(json, 'questions') ? undefined : ((json['questions'] as Array<any>).map(GetQuestionDtoFromJSON)),
        'surveyCompanies': !exists(json, 'surveyCompanies') ? undefined : ((json['surveyCompanies'] as Array<any>).map(GetSurveyCompanyDtoFromJSON)),
        'surveyEmployees': !exists(json, 'surveyEmployees') ? undefined : ((json['surveyEmployees'] as Array<any>).map(GetSurveyEmployeeDtoFromJSON)),
        'frequency': json['frequency'],
        'contractorType': json['contractorType'],
        'validityPeriodDays': json['validityPeriodDays'],
        'remind': json['remind'],
        'active': json['active'],
        'startDate': !exists(json, 'startDate') ? undefined : (json['startDate'] === null ? null : new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (json['endDate'] === null ? null : new Date(json['endDate'])),
        'emailSubject': !exists(json, 'emailSubject') ? undefined : json['emailSubject'],
        'emailSubjectEn': !exists(json, 'emailSubjectEn') ? undefined : json['emailSubjectEn'],
        'emailBody': !exists(json, 'emailBody') ? undefined : json['emailBody'],
        'emailBodyEn': !exists(json, 'emailBodyEn') ? undefined : json['emailBodyEn'],
        'contactType': !exists(json, 'contactType') ? undefined : GetDictionaryDtoFromJSON(json['contactType']),
        'sendToGeneral': !exists(json, 'sendToGeneral') ? undefined : json['sendToGeneral'],
        'clientGroupId': !exists(json, 'clientGroupId') ? undefined : json['clientGroupId'],
        'owner': !exists(json, 'owner') ? undefined : GetEmployeeDtoFromJSON(json['owner']),
        'ts': !exists(json, 'ts') ? undefined : (new Date(json['ts'])),
        'creator': !exists(json, 'creator') ? undefined : GetEmployeeDtoFromJSON(json['creator']),
        'creationTs': !exists(json, 'creationTs') ? undefined : (new Date(json['creationTs'])),
    };
}

export function GetSurveyDtoToJSON(value?: GetSurveyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'name': value.name,
        'nameEn': value.nameEn,
        'questions': value.questions === undefined ? undefined : ((value.questions as Array<any>).map(GetQuestionDtoToJSON)),
        'surveyCompanies': value.surveyCompanies === undefined ? undefined : ((value.surveyCompanies as Array<any>).map(GetSurveyCompanyDtoToJSON)),
        'surveyEmployees': value.surveyEmployees === undefined ? undefined : ((value.surveyEmployees as Array<any>).map(GetSurveyEmployeeDtoToJSON)),
        'frequency': value.frequency,
        'contractorType': value.contractorType,
        'validityPeriodDays': value.validityPeriodDays,
        'remind': value.remind,
        'active': value.active,
        'startDate': value.startDate === undefined ? undefined : (value.startDate === null ? null : value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate === null ? null : value.endDate.toISOString()),
        'emailSubject': value.emailSubject,
        'emailSubjectEn': value.emailSubjectEn,
        'emailBody': value.emailBody,
        'emailBodyEn': value.emailBodyEn,
        'contactType': GetDictionaryDtoToJSON(value.contactType),
        'sendToGeneral': value.sendToGeneral,
        'clientGroupId': value.clientGroupId,
        'owner': GetEmployeeDtoToJSON(value.owner),
        'ts': value.ts === undefined ? undefined : (value.ts.toISOString()),
        'creator': GetEmployeeDtoToJSON(value.creator),
        'creationTs': value.creationTs === undefined ? undefined : (value.creationTs.toISOString()),
    };
}

